<template>
	<div class="record_list_item bg-white" @click="$emit('click')">
		<div class="main border-bottom">
			<div class="content">
				<p class="title">{{ title }}</p>
				<p class="status" :class="getStatusClass">{{ $status.payStatus[status] }}</p>
			</div>
			<div class="create_time">
				<span v-if="status == 2">支付时间：</span>
				<span v-else-if="status == 3">取消时间：</span>
				<span v-else>创建时间：</span>
				<span>{{ createTime }}</span>
			</div>
		</div>
		<div class="footer">
			<p class="price">￥{{ price | priceFilter }}</p>
			<van-button v-if="status == 1" class="footer_btn" type="primary" size="small" @click.stop="$emit('pay')">
				立即支付
			</van-button>
			<van-button
				v-if="status == 2"
				class="footer_btn"
				type="primary"
				size="small"
				@click.stop="$emit('preview')"
			>
				查看订单
			</van-button>
			<van-button v-if="status == 3" class="footer_btn" size="small" @click.stop="$emit('delete')">
				删除订单
			</van-button>
		</div>
	</div>
</template>

<script>
export default {
    name: 'RecordListItem',
    props: {
        title: {
            type: String,
            default: ''
        },
        status: {
            type: [String, Number],
            default: ''
        },
        createTime: {
            type: String,
            default: ''
        },
        price: {
            type: [String, Number],
            default: ''
        }
    },
    computed: {
        getStatusClass () {
            return {
                1: 'danger',
                2: 'success',
                3: 'normal'
            }[this.status]
        }
    }
};
</script>

<style scoped lang="less">
.record_list_item {
	border-radius: 16px;
	padding: 32px 16px;
	> div {
		padding: 0 12px;
		&.main {
			padding-bottom: 32px;
			.content {
				display: flex;
				justify-content: space-between;
				align-items: center;
				.title {
					flex: auto;
					font-family: PingFangSC-Semibold;
					font-size: 32px;
					font-weight: normal;
					color: #1f2329;
					word-break: break-all;
				}
				.status {
					text-align: right;
					flex: 0 0 100px;
					font-family: PingFangSC-Regular;
					font-size: 28px;
					font-weight: normal;
					&.danger {
						color: @danger;
					}
					&.normal {
						color: #bbbfc4;
					}
					&.success {
						color: @primary;
					}
				}
			}
			.create_time {
				font-family: PingFangSC-Regular;
				font-size: 28px;
				font-weight: normal;
				color: #1f2329;
				margin-top: 14px;
				span {
					color: #bbbfc4;
				}
			}
		}
		&.footer {
			padding-top: 32px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.price {
				font-family: PingFangSC-Regular;
				font-size: 30px;
				font-weight: normal;
				color: @primary;
			}
			.footer_btn {
				width: 140px;
				height: 60px;
				line-height: 60px;
				border-radius: 12px;
				font-family: PingFangSC-Medium;
			}
		}
	}
}
</style>
